//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Questions",
  emits: ['close'],
  props: {
    content: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    activeCategory: {
      type: String,
      reuqired: false,
      default() {
        return '';
      }
    },
    sectionType: {
      type: String,
      reuqired: false,
      default() {
        return '';
      }
    },
  },
  data() {
    return {
      isShow: true,
      questionsCounter: 3,
    }
  },
  computed: {
    getQuestionsCounter() {
      if (this.activeCategory === '5') {
        return this.content.length;
      }
      return this.questionsCounter;
    }
  }
};
